import React from 'react';
import PropTypes from 'prop-types';
import { Card } from 'react-bootstrap';
import { CompilaQuestionarioKpisValori } from './CompilaQuestionarioKpisValori.js';
// import { csvcSoggettiListV1 } from '../components-csvc-one/testSoggettiList.js';
import  { useSelector } from 'react-redux'

/*
function nomeEsteso(key) {
    const pair = csvcSoggettiListV1.find(pair => pair.id === key);
    return pair ? pair.nome.toUpperCase() : null;
}
*/
function nomeEsteso(key) {
  const questionarioCorrente = useSelector((state) => state.questCorrente);
  // Estraggo Array stakeholders filtrato
  // const excludedIds = ['AZ', 'CT'];
  // const stakeholdersFiltered = questionarioCorrente.stakeholders.filter(stakeholder => !excludedIds.includes(stakeholder.id));
  const pair = questionarioCorrente.stakeholders.find(pair => pair.id === key);
  return pair ? pair.alias.toUpperCase() : null;
}

export const CompilaQuestionarioKpis = (props) => {
  return (
    <>
    {props.kpis.map((kpi) => (
      <>
              <Card key={kpi.key}  style={{marginBottom:"2%", marginTop:"2%"}}>
                <Card.Body>
                  <Card.Title >
                  <h6 className="text-primary mb-0" style={{marginBottom:"1%"}}> <strong>OPPORTUNITÀ PER STAKEHOLDER</strong></h6>
                  </Card.Title>
                  <Card.Text> 
                    {kpi.stakholderOpportunita.map((opportunita) => (<>
                      <Card key={opportunita.key} style={{marginBottom:"1%", padding:"1%",}}>
                        {/* <h7>( CompilaQuestionarioKpis row 62 - kpi.key: {kpi.key} - opportunita.key: {opportunita.key})</h7> */}
                        <h6 className="text-primary mb-0"><span className="text-info fw-medium">{nomeEsteso(opportunita.stakeholder)} - {opportunita.codiceCsvc} - {opportunita.nome=='OPPORTUNITA' ? 'OPPORTUNITÀ' : opportunita.nome}</span></h6>       
                          <CompilaQuestionarioKpisValori 
                              kpiValueKey={opportunita.key}
                              descrizione={opportunita.descrizione}
                              stakeholder={opportunita.stakeholder}
                              sottoconto=''
                              helpRowsObjectArray={opportunita.helpRowsObjectArray}
                              color='#FF0000;'
                          />
                        </Card>
                    </>))}
                    </Card.Text> 
                </Card.Body>
              </Card>

              <Card key={kpi.kpiCodice}  style={{marginBottom:"2%"}}>
                <Card.Body>
                  <Card.Title>
                  <h6 className="text-primary mb-0" style={{marginBottom:"1%"}}><strong>OPPORTUNITÀ PER L'AZIENDA</strong></h6>
                  </Card.Title>
                  <Card.Text> 
                    {kpi.bilancioPoste.map((bilancioPosta => bilancioPosta.enabled ?
                      (<>
                        <Card key={bilancioPosta.codiceCsvc} style={{marginBottom:"1%", padding:"1%", }}>
                          {/* <h7>( CompilaQuestionarioKpis row 87 - kpi.key: {kpi.key} - bilancioPosta.key: {bilancioPosta.key})</h7> */}
                          <h6 className="text-primary mb-0"><span className="text-info fw-medium">{bilancioPosta.sottoconto} - {bilancioPosta.codiceCsvc} - {bilancioPosta.nome=='OPPORTUNITA' ? 'OPPORTUNITÀ' : bilancioPosta.nome}</span></h6>   
            
                            <CompilaQuestionarioKpisValori 
                              kpiValueKey={bilancioPosta.key}
                              descrizione={bilancioPosta.descrizione}
                              stakeholder={''}
                              sottoconto={bilancioPosta.sottoconto}
                              helpRowsObjectArray={bilancioPosta.helpRowsObjectArray}
                              color='#0000FF;'
                            />

                        </Card>
                      </>)
                      :(<>
                      </>)
                    ))}

            </Card.Text>
          </Card.Body>
        </Card>
      </>))}
    </>
  );
};

CompilaQuestionarioKpis.propTypes = {
  kpis: PropTypes.array.isRequired
};


/*

// riga KPI con numero Marino
            <h4 className="text-primary mb-0" style={{margin:"2%"}}><strong>KPI :</strong> {/* - (CompilaQuestionarioKpis: {kpi.key}) * /} </h4>
            <h5 className="text-primary mb-0" style={{margin:"2%"}}><strong>{kpi.codiceCsvc}</strong> {/* - (CompilaQuestionarioKpis: {kpi.key}) * /} </h5>

export const CompilaQuestionarioKpis = (props) => {
  return (
    <>
    {props.kpis.map((kpi) => (
      <>
        <Card key={kpi.key}  style={{marginBottom:"2%"}}>
          <Card.Body>
            <Card.Title>
            <h5 className="text-primary mb-0" style={{marginBottom:"1%"}}><strong>{kpi.codiceCsvc}</strong> {/* - (CompilaQuestionarioKpis: {kpi.key}) * /} </h5>
            </Card.Title>
            <Card.Text> 

              <Card key={kpi.key}  style={{marginBottom:"2%"}}>
                <Card.Body>
                  <Card.Title >
                  <h6 className="text-primary mb-0" style={{marginBottom:"1%"}}> <strong>OPPORTUNITÀ PER STAKEHOLDER</strong></h6>
                  </Card.Title>
                  <Card.Text> 
                    {kpi.stakholderOpportunita.map((opportunita) => (<>
                      <Card key={opportunita.key} style={{marginBottom:"1%", padding:"1%",}}>
                        {/* <h7>( CompilaQuestionarioKpis row 62 - kpi.key: {kpi.key} - opportunita.key: {opportunita.key})</h7> * /}
                        <h6 className="text-primary mb-0"><span className="text-info fw-medium">{nomeEsteso(opportunita.stakeholder)} - {opportunita.codiceCsvc} - {opportunita.nome=='OPPORTUNITA' ? 'OPPORTUNITÀ' : opportunita.nome}</span></h6>       
                          <CompilaQuestionarioKpisValori 
                              kpiValueKey={opportunita.key}
                              descrizione={opportunita.descrizione}
                              stakeholder={opportunita.stakeholder}
                              sottoconto=''
                              helpRowsObjectArray={opportunita.helpRowsObjectArray}
                              color='#FF0000;'
                          />
                        </Card>
                    </>))}
                    </Card.Text> 
                </Card.Body>
              </Card>

              <Card key={kpi.kpiCodice}  style={{marginBottom:"2%"}}>
                <Card.Body>
                  <Card.Title>
                  <h6 className="text-primary mb-0" style={{marginBottom:"1%"}}><strong>VALORE AGGIUNTO RICLASSIFICATO</strong></h6>
                  </Card.Title>
                  <Card.Text> 
                    {kpi.bilancioPoste.map((bilancioPosta => bilancioPosta.enabled ?
                      (<>
                        <Card key={bilancioPosta.codiceCsvc} style={{marginBottom:"1%", padding:"1%", }}>
                          {/* <h7>( CompilaQuestionarioKpis row 87 - kpi.key: {kpi.key} - bilancioPosta.key: {bilancioPosta.key})</h7> * /}
                          <h6 className="text-primary mb-0"><span className="text-info fw-medium">{bilancioPosta.sottoconto} - {bilancioPosta.codiceCsvc} - {bilancioPosta.nome=='OPPORTUNITA' ? 'OPPORTUNITÀ' : bilancioPosta.nome}</span></h6>   
            
                            <CompilaQuestionarioKpisValori 
                              kpiValueKey={bilancioPosta.key}
                              descrizione={bilancioPosta.descrizione}
                              stakeholder={''}
                              sottoconto={bilancioPosta.sottoconto}
                              helpRowsObjectArray={bilancioPosta.helpRowsObjectArray}
                              color='#0000FF;'
                            />

                        </Card>
                      </>)
                      :(<>
                      </>)
                    ))}
                  </Card.Text> 
                </Card.Body>
              </Card>
 
            </Card.Text>
          </Card.Body>
        </Card>
      </>))}
    </>
  );
};

*/